import { Reveal, Lines, SectionTag } from "../site/Motion";
import NetworkMap from "../site/NetworkMap";

export function NetworkSection() {
  return (
    <section id="network" data-testid="network-section" className="relative overflow-hidden border-t border-white/10 bg-ink py-28 sm:py-40">
      <div className="mx-auto max-w-[1600px] px-5 sm:px-10">
        <SectionTag index="14" label="Rete SWAPA" />
        <h2 className="mt-10 font-display font-extrabold uppercase leading-[0.92] tracking-tight">
          <Lines lines={["Find SWAPA."]} className="text-4xl text-white sm:text-6xl lg:text-7xl" />
        </h2>
        <Reveal delay={0.2}>
          <p className="mb-12 mt-6 max-w-lg text-base leading-relaxed text-zinc-400">
            Test drive, vendita e assistenza: la rete SWAPA nelle principali città italiane.
            Cerca per CAP, città o lasciati guidare dalla mappa.
          </p>
        </Reveal>
        <Reveal y={70}>
          <NetworkMap compact />
        </Reveal>
      </div>
    </section>
  );
}
